export default "__VITE_PUBLIC_ASSET__7a25e534__"